import React from 'react';
import { Helmet } from 'react-helmet-async';
export const ConsumerMetaTags = ({ title, description, canonicalUrl }) => {
    return (React.createElement(Helmet, null,
        React.createElement("title", null, title),
        React.createElement("meta", { name: "og:title", content: title }),
        React.createElement("meta", { name: "twitter:title", content: title }),
        React.createElement("meta", { name: "description", content: description }),
        React.createElement("meta", { name: "og:description", content: description }),
        React.createElement("meta", { name: "twitter:description", content: description }),
        React.createElement("link", { rel: "canonical", href: canonicalUrl })));
};
